<template>
  <div>
    <confirm-dialog ref="confirm">
      <v-row slot="action" no-gutters>
        <v-spacer></v-spacer>
        <v-btn
          color="darkColor"
          small
          ref="yes"
          rounded
          class="normal-letter-spacing px-12 py-4 ml-2"
          style="color: white"
          @click="confirmDialogConfirmFunction()"
          :disabled="disabelConfirm"
        >
          بله
        </v-btn>
        <v-btn
          small
          rounded
          text
          ref="no"
          class="normal-letter-spacing px-12 confirm-cancel-btn"
          @click="confirmDialogCancelFunction()"
        >
          خیر
        </v-btn>
      </v-row>
    </confirm-dialog>
    <v-dialog width="400" v-model="showAddEditModal" persistent>
      <v-card>
        <v-row no-gutters>
          <v-col cols="12" class="modal-header py-5">
            <v-row no-gutters>
              <v-spacer></v-spacer>
              <v-icon color="darkColor">{{ modalIcon }}</v-icon>
              <span class="modal-title-text mr-2">{{ modalTitle }}</span>
              <v-spacer></v-spacer>
            </v-row>
          </v-col>
        </v-row>
        <v-card-text class="mt-12">
          <v-row no-gutters>
            <v-col cols="12">
              <v-text-field
                type="text"
                v-model="generalTriageQuestion.title"
                dense
                outlined
                v-on:keyup.enter="showConfirmDialogFunction()"
                label="عنوان*"
                clearable
                clear-icon="mdi-close-circle-outline"
                class="input-label"
                prepend-inner-icon="mdi-subtitles mdi-18px"
                tabindex="1"
                :autofocus="true"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                type="text"
                v-model="generalTriageQuestion.tag"
                dense
                outlined
                v-on:keyup.enter="showConfirmDialogFunction()"
                label="کلمه کلیدی"
                clearable
                clear-icon="mdi-close-circle-outline"
                class="input-label"
                prepend-inner-icon="mdi-clipboard-list mdi-18px"
                tabindex="2"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer></v-spacer>
          <v-btn
            color="darkColor"
            @click="showConfirmDialogFunction()"
            dark
            rounded
            class="normal-letter-spacing px-12"
          >
            ثبت
          </v-btn>
          <v-btn
            rounded
            color="darkColor"
            outlined
            @click="cancelAddEditFunction()"
            class="normal-letter-spacing px-10"
          >
            انصراف
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-row no-gutters class="table-content">
      <v-col cols="12" class="mr-2">
        <v-img :src="tableImg.val">
          <v-row>
            <v-col cols="3">
              <v-img :src="tableTitleImage.val" contain max-height="14vh" max-width="27vh">
                <v-row>
                  <v-col cols="1"></v-col>
                  <v-col class="header-title" cols="10">
                    <span class="header-title-content">سوالات عمومی</span>
                  </v-col>
                  <v-spacer></v-spacer>
                </v-row>
              </v-img>
            </v-col>
            <v-col cols="1" class="mr-n13" v-if="!myIsRoot">
              <v-btn
                class="mx-2 mt-3 mr-n16"
                fab
                dark
                small
                @click="backToAnswerPage()"
                color="darkColor"
                elevation="0"
              >
                <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
              </v-btn>
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="2" class="text-left">
              <v-btn
                @click="showSiteMap()"
                v-if="!myIsRoot"
                class="ml-2 mt-3"
                outlined
                fab
                x-small
                color="darkColor"
              >
                <v-icon color="darkColor">mdi-clipboard-text-clock mdi-18px</v-icon>
              </v-btn>
              <v-btn
                rounded
                color="darkColor"
                dark
                @click="enableAddEditFunction(1, 0)"
                class="mt-3 normal-letter-spacing ml-3"
              >
                <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
                افزودن سوال
              </v-btn>
            </v-col>
          </v-row>
          <v-row no-gutters class="background-main mx-2 mt-3">
            <v-col cols="12">
              <v-card height="73vh" elevation="0" class="card-width body-card">
                <v-card-text>
                  <v-row class="path py-3" v-if="siteMap">
                    <v-col cols="1">
                      <span class="path-title mt-2">سوالات عمومی</span>
                    </v-col>
                    <v-col cols="10" class="mt-2 mb-2">
                      <v-row>
                        <span
                          class="path-chips mr-2"
                          v-for="item in siteMapItems"
                          :key="item.id"
                          @click="goToSiteMapItem(item)"
                        >
                          {{ item.title }}
                        </span>
                      </v-row>
                    </v-col>
                    <v-col cols="1" class="text-left mt-n4">
                      <v-icon @click="closeSiteMap()">mdi-close</v-icon>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="4" class="mt-8">
                      <div class="item-back" v-if="generalTriageQuestions"></div>
                      <v-card
                        elevation="2"
                        v-if="generalTriageQuestions"
                        class="item-card-position"
                      >
                        <v-card-text>
                          <v-row>
                            <v-col cols="12">
                              <v-row class="mr-2 mt-1">
                                <span class="item-title">عنوان:</span>
                                <span class="item-text mr-2">
                                  {{ generalTriageQuestions.title }}
                                </span>
                              </v-row>
                            </v-col>
                            <v-col cols="12">
                              <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" class="mt-1">
                              <v-row class="mr-2">
                                <span class="item-title">کلمه کلیدی:</span>
                                <span class="item-text mr-2">{{ generalTriageQuestions.tag }}</span>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-row no-gutters class="item-action-part mt-2">
                          <v-col cols="1"></v-col>
                          <v-col cols="1" class="my-3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="darkColor"
                                  style="cursor: pointer"
                                  @click="goToTriageAnswerPage(generalTriageQuestions)"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-message-processing mdi-24px
                                </v-icon>
                              </template>
                              <span>پاسخ</span>
                            </v-tooltip>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="1" class="my-3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="darkColor"
                                  style="cursor: pointer"
                                  @click="enableAddEditFunction(2, generalTriageQuestions.id)"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-pencil mdi-24px
                                </v-icon>
                              </template>
                              <span>ویرایش</span>
                            </v-tooltip>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="1" class="my-3">
                            <v-tooltip top>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  class="mr-5"
                                  color="darkColor"
                                  style="cursor: pointer"
                                  @click="showDeleteConfirmFunction(generalTriageQuestions.id)"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-delete
                                </v-icon>
                              </template>
                              <span>حذف</span>
                            </v-tooltip>
                          </v-col>
                          <v-col cols="1"></v-col>
                        </v-row>
                      </v-card>
                      <v-row v-if="!generalTriageQuestions" class="mt-16">
                        <v-spacer></v-spacer>
                        <span>سوالی برای نمایش وجود ندارد.</span>
                        <v-spacer></v-spacer>
                      </v-row>
                    </v-col>
                    <v-spacer></v-spacer>
                    <v-col cols="7">
                      <v-img :src="triageQuestionPic" class="pic" contain></v-img>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-img>
      </v-col>
    </v-row>
    <alert-component
      ref="snackRef"
      :snakTimeOut="snakTimeOut"
      :snackColor="snackColor"
      :snackText="snackText"
      :snakIcon="snakIcon"
    ></alert-component>
  </div>
</template>
<script>
  import confirmDialog from '../../components/ConfirmDialog.vue';
  import AlertComponent from '../../components/AlertComponent.vue';

  import snackBar from '@/Mixins/snackBar.js';
  import ShearedMixin from '@/Mixins/Shared.js';
  import pagination from '@/Mixins/Pagination';
  import ShearedHelper from '@/Helpers/Shared.js';
  import generalTriageQuestionMixin from '@/Mixins/Triage/GeneralTriageQuestionMixin';
  import TriageAnswerMixin from '@/Mixins/Triage/TriageAnswerMixin.js';
  import generalTriageQuestionHelper from '@/Helpers/Triage/GeneralTriageQuestionHelper';
  export default {
    name: 'GeneralTriageQuestionManagment',
    title: 'سوالات عمومی',
    inject: ['load', 'tableImg', 'tableTitleImage'],
    components: {
      confirmDialog,
      AlertComponent,
    },
    mixins: [
      pagination,
      ShearedMixin,
      generalTriageQuestionMixin,
      generalTriageQuestionHelper,
      TriageAnswerMixin,
      ShearedHelper,
      snackBar,
    ],
    created() {
      this.$root.$refs.GeneralTriageQuestion = this;
    },
    mounted() {
      this.mounteLoding();
    },
    data() {
      return {
        triageQuestionPic: require('@/assets/images/TriageQuestionPic.png'),
      };
    },
    methods: {
      mounte: function () {
        localStorage.setItem('qType', 'general');
        if (this.$route.params.id) {
          this.myIsRoot = false;
          let route = this.$route.params.id;
          this.previousAnswerId = Number(route);
          //from triageanswer mixin
          this.getQuestionWithAnswerIdFunction(Number(route));
        } else {
          this.getGeneralTriageQuestions();
          this.myIsRoot = true;
        }
      },
    },
    computed: {
      generalTriageQuestionsFilteredList() {
        return this.allGeneralTriageQuestions.filter((u) => {
          return u.title.toLowerCase().includes(this.searchTitle.toLowerCase());
        });
      },
    },
  };
</script>
<style scoped>
  .confirm-cancel-btn {
    border: solid 1px var(--dark-color);
    padding-top: 13px;
    padding-bottom: 15px;
    color: var(--dark-color);
  }
  .body-card {
    overflow-y: auto !important;
    overflow-x: hidden;
  }
  .pic {
    margin-top: 2vh !important;
  }
  .item-back {
    position: absolute;
    background: var(--dark-color);
    height: 20vh;
    width: 16vh;
    border-radius: 7px !important;
  }
  .item-card-position {
    margin-top: 4vh;
    margin-right: 6vh;
  }
  .item-title {
    font-weight: 600;
    font-size: 14px;
    color: #212121;
  }
  .item-text {
    font-weight: 400;
    font-size: 13px;
    color: #212121;
  }
  .item-action-part {
    background: #eef6ff;
  }
  .path {
    background: var(--background-color) !important;
    border-radius: 12px !important;
  }
  .path-chips {
    background: #d0e6ff;
    border-radius: 30px !important;
    padding-left: 22px !important;
    padding-right: 22px !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }
  .path-title {
    font-weight: 600;
    font-size: 15px;
    color: black;
  }
  @media only screen and (min-width: 1280px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1366px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 98.5% !important;
      margin-right: 2vh !important;
    }
  }
  @media only screen and (min-width: 1536px) {
    .table-content {
      margin-top: 1vh !important;
    }
    .card-width {
      width: 99% !important;
      margin-right: 1vh !important;
    }
  }
</style>
